export function logProviderNameV106(log) {
  const name = String(log?.channel_name || '').trim();
  if (name) return name;
  const id = log?.channel ?? log?.channel_id;
  if (Number.isInteger(Number(id)) && Number(id) > 0) return `#${id}`;
  return String(log?.provider_family || '').trim() || '-';
}
